import React from 'react';

import { Button } from 'modules/cxi/components/button';
import { useCXI } from 'modules/cxi/useCXI';

import { Container } from '../container';
import * as Styled from './StyledMentoringFinished';

export const MentoringFinished = () => {
    const { t, modal, setModal } = useCXI();
    const { match } = modal;

    return (
        <Styled.MentoringFinished as={Container.Slim}>
            <Container.Head image={match.startup.logoUrl} />

            <Container.Body>
                <Styled.Title>{t('modal.MentoringFinished.title')}</Styled.Title>
                <Styled.Descr>{t('modal.MentoringFinished.description')}</Styled.Descr>
            </Container.Body>

            <Container.Feet>
                <Button onClick={() => setModal(null)}>
                    <span className="text">{t('modal.close')}</span>
                </Button>
            </Container.Feet>
        </Styled.MentoringFinished>
    );
};
